<template>
  <div class="page">
    <v-touch @swipeleft="doNext" @swiperight="doPrev" :swipe-options="{threshold:50,direction: 'horizontal'}" class="v-touch">
      <div class="timer">
        <div class="num">{{active+1}}/{{ questions.length }}</div>
        <van-progress :percentage="(active+1)*100/questions.length" :show-pivot="false" stroke-width="6" class="progress"></van-progress>
        <div class="time"><span class="clock">{{ duration }}</span> <icon name="underway-o" color="#999" /></div>
      </div>

      <template v-for="(que,idx) in questions">
      <div :class="['que-panel',{'active':active === idx}]" v-if="active===idx" :key="que.id">
        <div class="question" >
          <div class="title">
            <tag :type="['primary','success','warning','info','danger'][que.type]" plain>{{ types[que.type] }}</tag>
            <span>{{idx+1}}、</span>
            <div v-html="que.title" style="display: inline"></div>
          </div>
          <div class="options" v-if="que.type<2">
            <div :class="['item',{'right': isActive(que,i) }]" v-for="(option,i) in que.optionList" :key="i" @click="doSelect(que,option,i)">
              <span class="letter">{{ String.fromCharCode(65+i)}}</span>
              <span class="name" v-html="option.title"></span>
            </div>
          </div>
          <div class="input-area" v-if="que.type == 4">
            <field v-model="que.selected" rows="5" ref="queField" autosize type="textarea" placeholder="请填写您的答案" @blur="doInput(que)" />
          </div>
        </div>

      </div>
      </template>
    </v-touch>
    <div class="footer">
      <div class="tools">
        <div class="menu" @click="doPrev"><icon name="arrow-left" size="20px" color="#00aaea" /><div class="name">上一题</div></div>
        <div class="menu" @click="toSheet"><icon name="label-o" size="20px" color="#00aaea" /><div class="name">答题卡</div></div>
        <div class="menu" @click="doFinish"><icon name="back-top" size="20px" color="#00aa ea" /><div class="name">交　卷</div></div>
        <div class="menu" @click="doNext"><icon name="arrow" size="20px" color="#00aaea" /><div class="name">下一题</div></div>
      </div>
    </div>

    <popup v-model="answerSheet"  position="bottom" :style="{ height: '50%' }" class="answer-sheet">
      <div class="header">答题卡</div>
      <div class="status-bar">
        <div class="actv">当前</div>
        <div class="undo">未做</div>
        <div class="right">已做</div>
      </div>
      <div class="que-idx-list">
        <div :class="['item',{'active':active === idx,'right':que.selected}]" v-for="(que,idx) in questions" :key="idx" @click="jump(idx)">{{idx+1}}</div>
      </div>
    </popup>
  </div>
</template>
<script>
import { getDayRecord,doDayFinish,doDayNext,fetchDayQuestions } from "@api/exam";
import { Tag,Icon,Popup,Progress as VanProgress,Field,Dialog,Toast} from 'vant';
import { formatSeconds } from "@utils/index";
import { decrypt } from "@utils/crypto";

export default {
  components: {
    Tag,Icon,Popup,VanProgress,Toast,Field
  },
  data: function() {
    return {
      startTime: new Date().getTime()/1000,
      duration:'',
      answerSheet:false,
      questions: [],
      records: [],
      types: ['单选题','多选题','判断题','填空题','问答题'],
      active:0,
      id: this.$route.params.id,
      starNum:0,
      rightNum:0,
      errorNum:0,
      activeNum:1
    };
  },
  created() {
    this.init();
  },
  methods: {
    toSheet(){
      this.answerSheet = true
    },
    init(){
      Toast.loading({ duration: 0,forbidClick: true,message:'加载中...'})
      this.fetchQuestions()
    },
    fetchQuestions(){
      fetchDayQuestions(this.id).then(res=> {
        let result = JSON.parse(decrypt(res.result))
        this.questions = result || []
        this.initRecord()
        Toast.clear()
      })
    },
    initRecord(){
      let that = this
      getDayRecord(this.id).then(res => {
        let data = res.result || {}
        if(data.finish){
          this.$router.replace({path:`/exam/practice/day/result/${this.id}`})
        }
        this.records = data.answers || []
        this.startTime = data.startTime || new Date().getTime()/1000
        this.active = data.index || 0

        let ansmap = this.records.reduce((r, i) => (r[i.id] = i, r), {})

        this.questions.forEach(o=> {
          if(ansmap[o.id]){
            Object.assign(o,ansmap[o.id])
          }
        })

        //开始计时
        setInterval(function(){
          that.duration = formatSeconds(new Date().getTime()/1000 - that.startTime)
        },1000)
      })
    },
    doSelect(que,option,idx){
      let that = this
      if(que.type == 1){    //多选题
        let array = que.multiple ? que.multiple.split(',') : []
        let i = array.indexOf(String.fromCharCode(65+idx))

        if(i == -1){          //取消选择
          array.push(String.fromCharCode(65+idx))
        }else{
          array.splice(i,1)
        }

        this.$set(que,'multiple',array.sort().join(','))
        this.$set(que,'selected',que.multiple || '')
      }else {
        this.$set(que,'selected',String.fromCharCode(65+idx))
        this.$set(que,'right',this.isRight(que,idx))

        setTimeout(function(){
          that.doNext()
        },300)
      }

      this.doRecord()
    },
    isRight(que,idx){
      if(que.type == 1 && !que.selected && que.multiple && que.multiple.includes(String.fromCharCode(65+idx)) ){         //多选题没做完，默认是正确的
        return true
      }else if(que.type == 0){
        return que.selected && que.answer.includes(String.fromCharCode(65+idx))
      }else{
        return false
      }
    },
    isActive(que,idx){
      if(que.type == 1 && que.multiple && que.multiple.includes(String.fromCharCode(65+idx)) ){         //多选题没做完，默认是正确的
        return true
      }else{
        return que.selected == String.fromCharCode(65+idx)
      }
    },
    jump(idx){
      this.active = idx
      this.answerSheet = false
    },
    doNext() {
      // this.$refs.queField.blur();
      if((this.active+1) < (this.questions.length)){
        this.active++
      }
    },
    doPrev() {
      if(this.active > 0){
        this.active--
      }
    },
    doInput(que){
      if(que.type == 4 && que.selected){
        this.$set(que,'right',false)
        this.doRecord()
      }
    },
    doRecord(){
      this.rightNum = this.questions.filter(q => q.right).length
      this.errorNum = this.questions.filter(q => q.selected && !q.right).length
      this.activeNum = this.questions.filter(q => q.selected).length

      let aws = this.questions.filter(x => x.selected).map(({id,selected,right,star}) => {return {id,selected,right,star}})

      let record = {
        index:this.active,
        rightNum:this.rightNum,
        errorNum:this.errorNum,
        activeNum:this.activeNum,
        totalNum:this.questions.length,
        answers:aws,
        startTime:this.startTime,
        endTime:new Date().getTime()/1000
      }

      if(aws && aws.length>0){
        doDayNext(this.id,record)
      }
    },
    doFinish(){
      let aws = this.questions.filter(x => x.selected).map(({id,selected,right,star}) => {return {id,selected,right,star}})
      let message = '您确认交卷吗？'
      if(aws.length<this.questions.length){
          message = `您还有${this.questions.length-aws.length}道题没做,确认交卷吗？`
      }

      Dialog.confirm({
        message: message,
      }).then(() => {
        this.doSubmit()
      })
    },
    doSubmit(){
      doDayFinish(this.id).then(() =>{
        this.$router.replace({path:`/exam/practice/day/result/${this.id}`})
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;

  .timer{
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #fff;
    height: 26px;
    margin-bottom: 8px;
    color:#999;

    .num{
      width: 50px;
      text-align: center;
    }
    .progress{
      flex:1;
      margin:0 8px;
    }
    .time{
      width:90px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .clock{
        margin-right: 5px;
      }
    }
  }

  .que-panel{
    height: calc(100vh - 50px);
    overflow-y: auto;
    display: none;
    &.active{
      display: block;
    }
  }

  .question {
    padding:20px 15px;
    background-color: #ffffff;
    margin-bottom: 20px;
    font-size: 14px;
    min-height: 200px;

    ::v-deep .van-tag{
      font-size: 12px;
      margin-right: 5px;
      font-weight: 400;
    }

    .title{
      margin-bottom: 15px;
      line-height: 24px;
      font-size: 14px;
      font-weight: 700;

      ::v-deep p:first-child{
        display: inline;
      }
      ::v-deep img{
        max-width: 100%;
      }
    }

    .options{
      .item{
        padding: 10px 8px;
        background-color: #f7f7f7;
        border:1px solid #f7f7f7;
        border-radius: 4px;
        margin:12px 0;
        display: flex;
        align-items: center;

        &.right{
          border:1px solid #799a74;
          background-color: #e9fde1;
        }
        &.error{
          border:1px solid #ca4848;
          background-color: #ffd9db;
        }

        .letter{
          margin: 0 10px;
        }
        .name{
          margin-left: 5px;
        }
      }
    }

    .input-area{
      background-color: #f7f7f7;
      border:1px solid #e6e6e6;
      border-radius: 2px;
    }
  }

  .answer {
    padding:10px 15px;
    background-color: #fff;
    min-height: 160px;

    .sign{
      margin:8px 0;
      font-size: 14px;

      .title{
        margin-right: 10px;
      }

      .letter{
        &.success{
          color:#1abb1d;
        }
        &.error{
          color:#e93323;
        }
      }
    }

    .analysis{
      border-top: 1px solid #f3f3f3;
      margin-top: 15px;
      padding: 10px 0;
      color: #696969;
      font-size: 14px;

      .title{
        margin:10px 0 5px;
        font-weight: 700;
        font-size: 12px;

        &:before{
          content: ' ';
          border-left: 3px solid #00aaea;
          height: 10px;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .desc{
        line-height: 22px;
        color:#3c3c3c;
        margin-bottom: 20px;
      }
    }

  }

  .manipulate{
    margin:30px 0;
    padding:0 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .prev{
      padding: 0 25px 0 20px;
    }
    .next{
      padding: 0 20px 0 25px;
    }
  }

  .footer{
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: content-box;
    height: 55px;
    background-color: #fff;
    box-sizing: border-box;
    border-top:1px solid #ececec;

    .tools{
      display: flex;
      align-items: center;
      vertical-align: middle;
      justify-content: center;
      width: 100%;
      font-size: 14px;

      .menu{
        flex:1;
        text-align: center;
        align-items: center;
        margin:8px 0;
      }
      &.que-num{
        margin-right: 0;
      }

    }
  }

  .answer-sheet{
    font-size: 12px;

    .header{
      font-size: 14px;
      font-weight: 700;
      padding: 10px 0 ;
      text-align: center;
    }
    .status-bar{
      height: 42px;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .actv{
        margin-right: 15px;
        &:before{
          content: ' ';
          border: 1px solid #00aaea;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .undo{
        margin-right: 15px;
        &:before{
          content: ' ';
          border:1px solid #ccc;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .right{
        margin-right: 15px;
        &:before{
          content: ' ';
          border:1px solid #799a74;
          background-color: #e9fde1;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .error{
        margin-right: 10px;
        &:before{
          content: ' ';
          border:1px solid #ca4848;
          background-color: #ffd9db;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

    }
    .que-idx-list{
      display: flex;
      flex-wrap: wrap;
      padding: 10px 5px;

      .item{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:8px 10px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border:1px solid #ccc;

        &.right{
          border:1px solid #1abb1d;
          background-color: #e9fde1;
          color:#1abb1d;
        }
        &.error{
          border:1px solid #ca4848;
          background-color: #ffd9db;
          color:#ca4848;
        }
        &.active{
          border:1px solid #00aaea;
          background-color: #FFFFFF;
          color:#00aaea;
        }
      }

    }
  }

}
</style>
